import React from "react";
import LegalPage from "./LegalPage";

const PrivacyPolicy = () => {
  return (
    <LegalPage title="Privacy Policy">
      <p><strong>Last Updated:</strong> 2024-2025</p>

      <p>
        Zolang Nexora Softwares (“we”, “our”, “us”) respects your privacy and
        is committed to protecting the personal information of users.
      </p>

      <h4>1. Information We Collect</h4>
      <p>
        We may collect personal information such as name, email address,
        mobile number, and business details when you interact with our
        services or website.
      </p>

      <h4>2. Use of Information</h4>
      <p>
        Information collected is used solely to provide services, respond
        to enquiries, improve service quality, and comply with legal
        requirements.
      </p>

      <h4>3. Data Protection</h4>
      <p>
        We implement reasonable security practices to protect your data
        from unauthorized access, misuse, or disclosure.
      </p>

      <h4>4. Third-Party Links</h4>
      <p>
        Our website may contain links to third-party platforms. We are not
        responsible for their privacy practices.
      </p>

      <h4>5. Contact Information</h4>
      <p>
        <strong>Zolang Nexora Softwares</strong><br />
        Mayiladuthurai, Tamil Nadu – 609203<br />
        Email: contact.in.dinesh@gmail.com<br />
        Phone: +91 6382585971
      </p>
    </LegalPage>
  );
};

export default PrivacyPolicy;
